module.exports = __webpack_public_path__ + "static/img/图层2.0403e2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cardSolution/图层2.png
// module id = nUkp
// module chunks = 0